import { ChatbotAnswer } from '../../domain/ChatbotSlice/ChatbotAnswer';
import { ChatbotAskTransporter } from '../../domain/ChatbotSlice/ChatbotAskTransporter';
import ApiWrapperAuthenticated from '../Common/ApiWrapperAuthenticated';

export class ChatbotTransporterRepository extends ApiWrapperAuthenticated<ChatbotAnswer> {
    constructor() {
        super('chatbot/transporter/');
    }

    async ask(message: ChatbotAskTransporter): Promise<ChatbotAnswer | null> {
        return await this.postAuthenticatedCustom({url: '', data: message});
    }
}
